import { createAction } from "typesafe-actions";
export var set = createAction("language/SET", function (resolve) {
  return function (languageId) {
    return resolve(languageId);
  };
});
export var clear = createAction("language/CLEAR");